class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.mobileDrawer = this.dataset.mobileDrawer;
    this.addToCart = this.dataset.cartForm;
    this.isMobile = new DeviceWidth().isMobile;
    this._onResize = throttle(this.updatePosition.bind(this), 200);
    this._intersectionObserver = null;

    if (this.isMobile) {
      this.bindEvents();
    }
  }

  connectedCallback() {
    if (this.addToCart) {
      this.querySelector('[data-submit]')?.addEventListener('click', () => {
        document.querySelector('.product-form form')?.dispatchEvent(new Event('submit'));
      });
    }

    this.updatePosition();
  }

  disconnectedCallback() {
    this._intersectionObserver?.disconnect();
    this._intersectionObserver = null;
    window.removeEventListener('resize', this._onResize);
  }

  bindEvents() {
    window.addEventListener('resize', this._onResize);

    this.querySelector('button')?.addEventListener('click', () => {
      const event = new CustomEvent('reloadCustomSelect', {
        detail: {
          name: 'select-size',
        },
        bubbles: true,
        cancelable: false,
        composed: true,
      });
      document.querySelector('[data-name="select-size"]')?.dispatchEvent(event);
    });
  }

  updatePosition() {
    const stickyButton = document.querySelector('.sticky-element');
    const observedElement = document.querySelector('.product-form');

    if (!stickyButton || !observedElement) return;

    this._intersectionObserver?.disconnect();

    this._intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const boundingClientRect = entry.boundingClientRect;
          const intersectionRect = entry.intersectionRect;

          if (entry.isIntersecting || boundingClientRect.bottom < intersectionRect.bottom) {
            stickyButton.classList.remove('fade-in');
          } else {
            stickyButton.classList.add('fade-in');
          }
        });
      },
      { threshold: 0 }
    );

    this._intersectionObserver.observe(observedElement);
  }
}

if (!customElements.get('sticky-button')) {
  customElements.define('sticky-button', StickyButton);
}
